// App Navigation Utilities
// Shared helpers for /app/* routes to ensure consistency

export const STORAGE_KEYS = {
  LAST_OUTLET_ID: "ra:last_outlet_id",
};

/**
 * Get outlet ID from URL query param or localStorage fallback
 */
export function getOutletId(searchParams) {
  return (
    searchParams.get("outlet") ||
    localStorage.getItem(STORAGE_KEYS.LAST_OUTLET_ID) ||
    null
  );
}

/**
 * Save outlet ID to localStorage
 */
export function setOutletId(id) {
  if (id) {
    localStorage.setItem(STORAGE_KEYS.LAST_OUTLET_ID, id);
  } else {
    localStorage.removeItem(STORAGE_KEYS.LAST_OUTLET_ID);
  }
}

/**
 * Remove outlet ID from localStorage (when invalid)
 */
export function clearOutletId() {
  localStorage.removeItem(STORAGE_KEYS.LAST_OUTLET_ID);
}

/**
 * Safe navigation - blocks web routes inside app
 */
export function safeNavigate(navigate, path) {
  if (path.startsWith("/outlet") || path.includes("/poster")) {
    console.error("🚫 Blocked web route in app:", path);
    return;
  }
  navigate(path);
}

/**
 * Navigate to web dashboard (escape hatch)
 */
export function navigateToDashboard() {
  window.location.href = "/dashboard";
}